export default __webpack_public_path__ + "static/media/ISR 2024 School Declaration Form.4d133911.pdf";